import store from "../.."
import { Browser } from "./Browser";
/**
 * @namespace UrlHelper 
 */
const UrlHelper = {
  /**
   * Gets Access buttons button type class name 
   * @param {string } buttonType button type  
   * @returns {string}
   */
  getStaticFileUrl(path) {

    const isAbsoluteURL = Browser.isAbsoluteURL(path);

    if (isAbsoluteURL) {
      return path;
    }

    const staticCDN = store.getState().settings?.urls?.imagesCdnUrl;
    const partnerGuild = store.getState().settings?.partnerGuid;
    return staticCDN ? `${staticCDN}/${partnerGuild}${path}` : path;

  },

  isPopupUrl(url) {
    const popupPath = '/popup/'
    return url?.includes(popupPath);
  }

}
export default UrlHelper;